import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';

@Injectable({
  providedIn: 'root'
})
export class SyslogApiService {

  private readonly sysLogUrl: string = 'externals/syslog';

  constructor(private http: HttpClient) {}

  public getSyslogs(parameters = {}): Observable<any> {
    const generatedSyslogsUrl = UrlQueryService.addQueryParameters(this.sysLogUrl, parameters);

    return this.http.get(generatedSyslogsUrl);
  }

  public getSyslog(syslogId): Observable<any> {
    return this.http.get(`${this.sysLogUrl}/${syslogId}`);
  }

  public editSyslog(syslog, syslogId): Observable<any> {
    return this.http.put(`${this.sysLogUrl}/${syslogId}`, syslog);
  }
}

